import { ScrollbarDirectiveFactory } from './';

export default {
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      elementScroll: 0,
      scrollModificator: 1,
      overflown: false,
      isChildOfDirectiveElement: null,
      isScrolling: false,
      currentScrollY: 0,
      currentScrollX: 0,
    };
  },
  mounted() {
    this.registerScrollbar();
    this.setEvents();
  },
  beforeDestroy() {
    this.removeEvents();
  },
  methods: {
    registerScrollbar() {
      ScrollbarDirectiveFactory.registerScrollbar(this);
    },
    /**
         * Функция и ее вспомогательные функции, вызываемые из CUIScrollbarDirective при изменении
         * размеров элемента, рассчитывающие соответствующие размеры скроллбара и поплавка.
         * Все параметры функции - это размеры в пикселях.
         * @param {number} elementScrollPrimary - вертикальный или горизонтальный скролл, в
         * зависимости от типа скроллбара
         * @param {number} elementScrollSecondary - скролл второго измерения, нужный для
         * абсолютного позиционирования скроллбара внутри скроллящегося элемента
         * @param {number} scrollLength - scrollWidth или scrollTop скроллящегося элемента.
         * scrollLength и clientLength передаются только когда меняются размеры этого элемента.
         * @param {number} clientLength - размеры видимой части скроллящегося элемента
         */
    render(elementScrollPrimary, elementScrollSecondary, scrollLength, clientLength) {
      const isLengthsChanged = scrollLength !== undefined || clientLength !== undefined;
      if (isLengthsChanged) {
        this.setOverflow(scrollLength, clientLength);
      }
      this.setElementScroll(elementScrollPrimary);

      if (this.isChildOfDirectiveElement === null) {
        this.checkScrollbarsLocation();
      }

      if (!this.overflown) { return; }

      /**
             * Вызывается через nextTick, так как setOverflow переключает v-if у всего скроллбара,
             * и в этот самый момент внутренние элементы не отрендерены, а $refs - пуст
             */
      this.$nextTick(() => {
        /**
                 * Вычисляет соотношение между размером скроллбара и размером элемента.
                 * Этот и следующие методы определены в каждом типе скроллбара по-своему.
                 */
        if (isLengthsChanged) {
          this.calcScrollModificator(scrollLength);
          this.calcBobberLength(clientLength);
        }

        this.applyBobberOffset();

        if (this.isChildOfDirectiveElement) {
          this.applyBarStyle(elementScrollPrimary, elementScrollSecondary);
        }
      });
    },
    setOverflow(scrollLength, clientLength) {
      if (scrollLength > clientLength) {
        this.overflown = true;
      } else {
        this.overflown = false;
      }
    },
    setElementScroll(elementScroll) {
      this.elementScroll = elementScroll;
    },
    /**
         * Функция проверяет, находится ли скроллбар внутри скроллящегося элемента. Это влияет
         * на render - если скроллбар внутри, ему нужно добавлять абсолютное позиционирование
         */
    checkScrollbarsLocation() {
      const {
        $directive: { element: directiveElement },
        $el: element,
      } = this;

      const checkParent = (element, targetElement) => {
        if (
          element.parentElement === targetElement ||
                    element.parentNode === targetElement
        ) {
          return true;
        } else if (!element.parentElement) {
          return false;
        }

        return checkParent(element.parentElement, targetElement);
      };

      this.isChildOfDirectiveElement = checkParent(element, directiveElement);
    },
    setEvents() {
      document.addEventListener('mouseup', this.handleBobberMouseup);
      document.addEventListener('mousemove', this.handleBobberMousemove);
      document.addEventListener('touchend', this.handleBobberTouchend);
      document.addEventListener('touchmove', this.handleBobberTouchmove);
    },
    removeEvents() {
      document.removeEventListener('mouseup', this.handleBobberMouseup);
      document.removeEventListener('mousemove', this.handleBobberMousemove);
      document.removeEventListener('touchend', this.handleBobberTouchend);
      document.removeEventListener('touchmove', this.handleBobberTouchmove);
    },
    handleBobberMousedown(event) {
      this.isScrolling = true;
      this.currentScrollY = event.clientY;
      this.currentScrollX = event.clienyX;
    },
    handleBobberTouchstart(event) {
      event.stopPropagation();
      this.isScrolling = true;
      this.currentScrollY = event.touches[0].clientY;
      this.currentScrollX = event.touches[0].clienyX;
    },
    handleBobberMouseup() {
      this.isScrolling = false;
      this.currentScrollY = 0;
      this.currentScrollX = 0;
    },
    handleBobberTouchend() {
      this.isScrolling = false;
      this.currentScrollY = 0;
      this.currentScrollX = 0;
    },
  },
};
